"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var icons_1 = require("@tiendanube/icons");
var Thumbnail_Button_1 = __importDefault(require("./Thumbnail.Button"));
var Text_1 = __importDefault(require("../Text"));
require("./Thumbnail.css");
function File(_a) {
    var aspectRatio = _a.aspectRatio, width = _a.width, _b = _a.disabled, disabled = _b === void 0 ? false : _b, ariaLabel = _a.ariaLabel, _c = _a.accept, accept = _c === void 0 ? "image/jpeg,image/gif,image/png" : _c, _d = _a.open, open = _d === void 0 ? false : _d, onChange = _a.onChange, _e = _a.multiple, multiple = _e === void 0 ? true : _e, helperText = _a.helperText;
    var inputRef = React.useRef(null);
    var handleOnClick = function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleChange = function (event) {
        event.stopPropagation();
        var files = event.target.files && Object.values(event.target.files);
        if (files) {
            onChange(files);
        }
    };
    React.useEffect(function () {
        var _a;
        if (open)
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, [open]);
    return (React.createElement(Thumbnail_Button_1.default, { aspectRatio: aspectRatio, width: width, ariaLabel: ariaLabel, onClick: handleOnClick, disabled: disabled, className: "nimbus--thumbnail-button-add" },
        React.createElement(icons_1.PlusCircleIcon, { size: "large" }),
        helperText && (React.createElement(Text_1.default, { size: "caption", appearance: "primary", bold: true, textAlign: "center" }, helperText)),
        React.createElement("input", { className: "nimbus--thumbnail-file", ref: inputRef, type: "file", accept: accept, id: "thumbnail-file", name: "thumbnail-file", multiple: multiple, onChange: handleChange })));
}
exports.default = File;
//# sourceMappingURL=Thumbnail.File.js.map